<template>
    <v-container grid-list-xs>
        <v-row>
            <v-col cols="12">
                <v-form :submit="submitSearch">
                    <v-expansion-panels variant="accordion" v-model="filterPanel">
                        <v-expansion-panel value="searchFiltersPanel" rounded="rounded-xl">
                            <v-expansion-panel-title style="color:#000000 !important; background-color: #e0e0e0ff; opacity: 1 !important"
                                                     v-ripple>
                                <v-row style="opacity: 1 !important">
                                    <v-col cols="3">
                                        <span class="v-card-title">Filtro de pesquisa</span>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text class="bg-grey-lighten-2">
                                <v-row density="compact">
                                    <v-col cols="12" md="6" align-self="start">
                                        <v-row align="start" density="compact">
                                            <v-col cols="1" md="2">
                                                <v-label>Pagamento</v-label>
                                            </v-col>
                                            <v-col cols="3" md="5">
                                                <v-text-field type="date" label="De" density="compact"
                                                              v-model="filters.payment_date_from">
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="3" md="5">
                                                <v-text-field type="date" label="Até" density="compact"
                                                              v-model="filters.payment_date_to">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="9" sm="6">
                                        <AutocompleteSelectGroup v-model="filters.group_ids"
                                                                 :multiple="true" v-if="hasAdminAccess" />
                                    </v-col>
                                    <v-col cols="12" md="3" sm="4">
                                        <v-select
                                                  :items="[50, 100, 200, 500]"
                                                  v-model="filters.itemsPerPage"
                                                  label="Resultados por página"
                                                  density="compact"
                                                  hide-details></v-select>
                                    </v-col>
                                </v-row>
                                <v-card-actions>
                                    <v-btn color="warning" @click="clearFilters()">
                                        <v-icon class="mr-2">mdi-broom</v-icon>
                                        Limpar Pesquisa
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <!-- <v-btn color="secondary" @click="downloadSearch">
                                        <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
                                        Download
                                    </v-btn> -->
                                    <v-btn color="primary" type="submit">
                                        <v-icon class="mr-2">mdi-magnify</v-icon>
                                        Pesquisar
                                    </v-btn>
                                </v-card-actions>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-form>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        <v-row align="center">
                            <v-col cols="9" v-if="showSelectHeaders">
                                <v-select
                                          label="Campos da tabela"
                                          item-title="title"
                                          return-object
                                          :items="headers"
                                          hide-details
                                          multiple
                                          clearable
                                          chips
                                          v-model="selectedHeaders"
                                          density="compact"
                                          @update:modelValue="saveSelectedHeaders"></v-select>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="1" style="min-height:71px;">
                                <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                        <v-btn icon density="compact"
                                               v-bind="props"
                                               variant="text">
                                            <v-icon color="grey-lighten-1"
                                                    @click="showSelectHeaders = !showSelectHeaders">
                                                mdi-cog
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Configurar Cabeçalhos</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-data-table-server class="elevation-1" density="compact"
                                         :items-per-page="filters.itemsPerPage"
                                         :headers="selectedHeaders"
                                         :items="payments"
                                         :items-length="serverTable.total"
                                         :loading="requestingApi"
                                         :search="searchFilter"
                                         return-object
                                         hide-default-footer
                                         expand-on-click
                                         fixed-header
                                         @update:options="loadItems">
                        <template v-slot:bottom>
                            <v-row>
                                <v-col cols="1" offset="8">
                                    <strong>Total</strong>
                                </v-col>
                                <v-col cols="2">
                                    <strong>{{ totalSum }}</strong>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <div class="text-center pt-2">
                                        <span>Mostrando os itens {{ serverTable.from }} até {{ serverTable.to }} de {{
                                            serverTable.total
                                        }}</span>
                                        <v-pagination density="compact"
                                                      v-model="serverTable.page"
                                                      :length="serverTable.maxPage"
                                                      show-first-last-page></v-pagination>
                                    </div>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.group="{ value }">
                            <span>{{ value.acronym }} - {{ value.name }}</span>
                        </template>
                        <template v-slot:item.status="{ value }">
                            <v-chip :color="$GROUP_PAYMENT_STATUS_DIC[value]?.color || 'grey'">{{
                                $GROUP_PAYMENT_STATUS_DIC[value]
                                ? $GROUP_PAYMENT_STATUS_DIC[value].label
                                : value
                            }}</v-chip>
                        </template>
                        <template v-slot:item.payment_date="{ value }">
                            <span v-if="value">{{
                                $moment.parseZone(value).format("DD/MM/YYYY")
                            }}</span>
                        </template>
                        <template v-slot:item.created_at="{ value }">
                            <span v-if="value">{{
                                $moment.parseZone(value).local().format("DD/MM/YYYY HH:mm:ss")
                            }}</span>
                        </template>
                        <template v-slot:item.amount="{ value }">
                            <span>{{
                                $filters.currency(value, 'BRL')
                            }}</span>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-menu>
                                <template v-slot:activator="{ props }">
                                    <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-if="item.payable"
                                                 @click="completePayment(item)">
                                        <v-list-item-title>
                                            <v-icon color="primary" class="mr-2">mdi-check</v-icon>
                                            Pago
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="item.errors || item.expired"
                                                 @click="recreatePayment(item)">
                                        <v-list-item-title>
                                            <v-icon color="primary" class="mr-2">mdi-refresh</v-icon>
                                            Reenviar
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="hasAdminAccess && item.cancellable"
                                                 @click="cancelPayment(item)">
                                        <v-list-item-title>
                                            <v-icon color="primary" class="mr-2">mdi-cancel</v-icon>
                                            Cancelar
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                        <template v-slot:expanded-row="{ columns, item }">
                            <tr>
                                <td class="text-center bg-detail-lighten-1" :colspan="columns.length">Lançamentos</td>
                            </tr>
                            <tr>
                                <td class="bg-detail-lighten-2">&nbsp;</td>
                                <td class="bg-detail-lighten-2">ID</td>
                                <td class="bg-detail-lighten-2">Situacao</td>
                                <td class="bg-detail-lighten-2">Vencimento</td>
                                <td class="bg-detail-lighten-2">Pagamento</td>
                                <td class="bg-detail-lighten-2">Valor</td>
                                <td class="bg-detail-lighten-2">Criação</td>
                                <td class="bg-detail-lighten-2">&nbsp;</td>
                            </tr>
                            <tr v-for="invoice in item.invoices">
                                <!-- <td :colspan="columns.length">
                            More info about {{ item.name }}
                        </td> -->
                                <td class="bg-detail-lighten-3"></td>
                                <td class="bg-detail-lighten-3">
                                    {{ invoice.id }}
                                </td>
                                <td class="bg-detail-lighten-3">
                                    <v-chip :color="$INVOICE_STATUS_DIC[invoice.status]?.color || 'grey'">{{
                                        $INVOICE_STATUS_DIC[invoice.status]
                                        ? $INVOICE_STATUS_DIC[invoice.status].label
                                        : invoice.status
                                    }}</v-chip>
                                </td>
                                <td class="bg-detail-lighten-3">{{
                                    $moment.parseZone(invoice.due_date).format("DD/MM/YYYY") }}</td>
                                <td class="bg-detail-lighten-3">
                                    <span v-if="invoice.payment_date">
                                        {{ $moment.parseZone(invoice.payment_date).format("DD/MM/YYYY") }}
                                    </span>
                                </td>
                                <td class="bg-detail-lighten-3">
                                    {{ $filters.currency(invoice.amount, "BRL") }}
                                </td>
                                <td class="bg-detail-lighten-3">
                                    {{ $moment.parseZone(invoice.created_at).local().format("DD/MM/YYYY HH:mm:ss") }}
                                </td>
                                <td class="bg-detail-lighten-3"></td>
                            </tr>
                        </template>
                    </v-data-table-server>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import AutocompleteSelectGroup from "../components/AutocompleteSelectGroup.vue";
import api from '@/services'

export default {
    components: {
        AutocompleteSelectGroup
    },
    props: {
        user: Object,
    },
    data() {
        return {
            requestingApi: false,
            initialized: false,
            searchFilter: null,
            filterPanel: "searchFiltersPanel",
            filters: {
                itemsPerPage: 200,
                orderBy: null,
                statuses: [],
                group_ids: [],
                description: null,
                payment_date_from: null,
                payment_date_to: null,
            },
            serverTable: {
                total: 0,
                from: 0,
                to: 0,
                page: 1,
                maxPage: 1,
            },
            showSelectHeaders: false,
            headers: [
                { title: "ID", key: "id", sortable: true },
                { title: "Situação", key: "status", sortable: true },
                { title: "Descrição", key: "description", sortable: true },
                { title: "Grupo", key: "group", sortable: true },
                { title: "Pagamento", key: "payment_date", sortable: true },
                { title: "Valor", key: "amount", sortable: true },
                { title: "Criação", key: "created_at", sortable: true },
                { title: "Ações", key: "actions", sortable: false },
            ],
            selectedHeaders: [],
            payments: [],
        }
    },
    created() {
        var vm = this;
        vm.loadParameters();
    },
    mounted() { },
    activated() { },
    methods: {
        saveSelectedHeaders() {
            var vm = this;
            try {
                localStorage.setItem(
                    "_group_payment_list_headers",
                    JSON.stringify(vm.selectedHeaders)
                );
            } catch (error) {
                console.error(error);
            }
        },
        loadParameters() {
            var vm = this;
            let _itemsPerPage = localStorage["_group_payment_itemsPerPage"];
            vm.filters.itemsPerPage = parseInt(_itemsPerPage || 200);

            try {
                let _headers = localStorage["_group_payment_list_headers"];
                vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
            } catch (error) {
                vm.selectedHeaders = vm.headers;
            }
        },
        clearFilters() {
            var vm = this;
            vm.searchFilter = null;
            vm.filters.itemsPerPage = 200;
            vm.filters.orderBy = null;
            vm.filters.description = null;
            vm.filters.payment_from = null;
            vm.filters.payment_to = null;
            vm.filters.statuses = [];
            vm.filters.group_ids = [];
        },
        submitSearch(page) {
            var vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                vm.serverTable.page = page || 1;
                return new Promise((resolve, reject) => {
                    api.groupPayment.list(vm.filters, vm.serverTable.page)
                        .then((result) => {
                            vm.initialized = true;
                            vm.payments = result?.data.map(o => {
                                const expired = o.status === vm.$GROUP_PAYMENT_STATUS_DIC.EXPIRED.value;
                                const errors = o.status === vm.$GROUP_PAYMENT_STATUS_DIC.ERROR.value;
                                const payable = o.status === vm.$GROUP_PAYMENT_STATUS_DIC.CREATED.value || (errors && o.payment_date < vm.$moment().format('YYYY-MM-DD'));
                                const cancellable = o.status === vm.$GROUP_PAYMENT_STATUS_DIC.ERROR.value || o.status === vm.$GROUP_PAYMENT_STATUS_DIC.CREATED.value;

                                return {
                                    ...o,
                                    expired,
                                    payable,
                                    errors,
                                    cancellable,
                                };
                            });
                            vm.serverTable.total = result?.total || vm.payments.length;
                            vm.serverTable.from = result?.from || 1;
                            vm.serverTable.to = result?.to || vm.payments.length;
                            vm.serverTable.maxPage = result?.last_page || 1;
                            vm.$notify({
                                type: "success",
                                text: "Pesquisa concluída",
                            });
                            vm.filterPanel = "";
                        })
                        .catch((err) => {
                            if (err.message) {
                                vm.$notify({
                                    type: "warn",
                                    text: err.message,
                                });
                            }
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                        });
                });
            }
        },
        loadItems({ page, itemsPerPage, sortBy }) {
            const vm = this;

            if (vm.initialized) {
                if (sortBy?.length > 0) {
                    vm.filters.orderBy = sortBy;
                } else {
                    vm.filters.orderBy = null;
                }
                vm.submitSearch(page);
            }
        },
        getAmountFromInvoice(invoice) {
            const vm = this;

            if (invoice.status === vm.$INVOICE_STATUS_DIC.PAID.value && invoice.paid_amount) {
                return invoice.paid_amount;
            } else {
                let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
                let _today = vm.$moment.parseZone().startOf("day");
                let _amount = invoice.amount;
                if (_dueDate > _today) {
                    _amount -= invoice.early_payment_discount || 0
                } else if (
                    _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
                ) {
                    _amount -= invoice.early_payment_discount || 0
                }
                return _amount
            }
        },
        completePayment(payment) {
            var vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.groupPayment.completePayment({ payment_id: payment.id })
                        .then((result) => {
                            vm.payments = vm.payments.map(p => p.id === payment.id ? result?.data : p);
                            vm.$notify({
                                type: "success",
                                text: "Pagamento Concluído",
                            });
                        })
                        .catch((err) => {
                            if (err.message) {
                                vm.$notify({
                                    type: "warn",
                                    text: err.message,
                                });
                            }
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                        });
                });
            }
        },
        recreatePayment(payment) {
            var vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.groupPayment.recreatePayment({ id: payment.id })
                        .then((result) => {
                            vm.payments = vm.payments.map(p => p.id === payment.id ? result?.data : p);
                            vm.$notify({
                                type: "success",
                                text: "Alterações Concluídas",
                            });
                        })
                        .catch((err) => {
                            if (err.message) {
                                vm.$notify({
                                    type: "warn",
                                    text: err.message,
                                });
                            }
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                        });
                });
            }
        },
        cancelPayment(payment) {
            const vm = this;

            vm.editPayment({
                id: payment.id,
                status: vm.$GROUP_PAYMENT_STATUS_DIC.CANCELED.value,
                invoices: payment.invoices.map(i => ({ id: i.id, status: vm.$INVOICE_STATUS_DIC.CANCELED.value }))
            });
        },
        editPayment(payment) {
            var vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.groupPayment.update(payment)
                        .then((result) => {
                            vm.payments = vm.payments.map(p => p.id === payment.id ? result?.data : p);
                            vm.$notify({
                                type: "success",
                                text: "Alterações Concluídas",
                            });
                        })
                        .catch((err) => {
                            if (err.message) {
                                vm.$notify({
                                    type: "warn",
                                    text: err.message,
                                });
                            }
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                        });
                });
            }
        }
    },
    computed: {
        hasFinancialAccess() {
            const vm = this;

            return vm.hasGroupAdminAccess || vm.hasAdminAccess || vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.FINANCIAL_ADMIN.value;
        },
        hasGroupAdminAccess() {
            const vm = this;

            return vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
        },
        hasAdminAccess() {
            const vm = this;

            return vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
        },
        totalSum() {
            const vm = this;

            return vm.$filters.currency(vm?.payments?.flatMap(p => p.invoices).map(i => vm.getAmountFromInvoice(i)).reduce((p, c) => { return p + c; }, 0) || 0, 'BRL');
        }
    },
    watch: {
        "filters.itemsPerPage"(newVal) {
            localStorage["_group_payment_itemsPerPage"] = newVal;
        },
        "serverTable.page"(newVal) {
            var vm = this;

            if (!isNaN(newVal)) {
                vm.submitSearch(newVal);
            }
        },
    }
}
</script>